export default {
    methods: {
        // zwraca dzień tygodnia na podstawie daty
        getShortDay(time) {
            if (time) {
                const today = new Date();
                const tomorrow = new Date(
                    new Date().setDate(today.getDate() + 1)
                );
                const date = new Date(time);
                const days = [
                    'Niedz.',
                    'Pn.',
                    'Wt.',
                    'Śr.',
                    'Czw.',
                    'Pt.',
                    'Sob.'
                ];

                if (date.toDateString() === today.toDateString()) {
                    return 'Dziś';
                }
                if (date.toDateString() === tomorrow.toDateString()) {
                    return 'Jutro';
                }
                return days[date.getDay()];
            }
            return null;
        }
    }
};
